import SimpleDateEdit from './SimpleDateEdit';

export default {
  __init__: [ 'simpleDateEdit' ],
  simpleDateEdit: [ 'type', SimpleDateEdit ]
};